
import { computed, defineComponent } from 'vue';
import { useStore } from '@/store';
import { DELETE_PROJECT } from '@/store/mutation-types';

export default defineComponent({
  name: 'ListView',
  methods: {
    deleteProj(id: string) {
      this.store.commit(DELETE_PROJECT, id);
    }
  },
  setup() {
    const store = useStore();
    return {
      store,
      projects: computed(() => store.state.projects)
    };
  }
});
